import { useState, useEffect } from 'react';

const Photoes = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isHovering, setIsHovering] = useState(false);
  
  // Sample data - replace with your actual images
  const galleryItems = [
    {
      id: 1,
      title: "Executive Team Meeting",
      description: "Our leadership team discussing strategy with key clients",
      imageUrl: "https://ik.imagekit.io/satfy9rkc/Indonesian%20Photoes/11.jpeg?updatedAt=1745579758916"
    },
    // {
    //   id: 2,
    //   title: "Product Launch",
    //   description: "Managers presenting our latest innovations to valued clients",
    //   imageUrl: "https://ik.imagekit.io/satfy9rkc/Indonesian%20Photoes/IMG-20250113-WA0004.jpg?updatedAt=1745579764111"
    // },
    // {
    //   id: 3,
    //   title: "Client Appreciation",
    //   description: "An evening of networking and relationship building",
    //   imageUrl: "https://ik.imagekit.io/satfy9rkc/Indonesian%20Photoes/IMG-20250113-WA0008.jpg?updatedAt=1745579765148"
    // },
    {
      id: 4,
      title: "Conference",
      description: "Our leadership team representing the organization globally",
      imageUrl: "https://ik.imagekit.io/satfy9rkc/HomePage/shared%20image%20(1).jpeg?updatedAt=1746159234958"
    },
    {
      id: 5,
      title: "Annual Celebration",
      description: "Celebrating our achievements with team members and clients",
      imageUrl: "https://ik.imagekit.io/satfy9rkc/Indonesian%20Photoes/9.jpeg?updatedAt=1745579758912"
    },
    {
      id: 6,
      title: "Team Building Retreat",
      description: "Senior managers and client representatives enjoying outdoor activities",
      imageUrl: "https://ik.imagekit.io/satfy9rkc/Indonesian%20Photoes/1.jpeg?updatedAt=1745579759169"
    },
  ];

  // Auto-scroll effect when not hovering
  useEffect(() => {
    let interval;
    if (!isHovering) {
      interval = setInterval(() => {
        setActiveIndex((current) => 
          current === galleryItems.length - 1 ? 0 : current + 1
        );
      }, 3000);
    }
    
    return () => clearInterval(interval);
  }, [galleryItems.length, isHovering]);

  // Function to handle smooth scrolling to the selected image
  const scrollToImage = (index) => {
    setActiveIndex(index);
    const scrollContainer = document.getElementById('image-scroll-container');
    const imageElement = document.getElementById(`image-${index}`);
    if (scrollContainer && imageElement) {
      scrollContainer.scrollTo({
        left: imageElement.offsetLeft - scrollContainer.offsetWidth / 2 + imageElement.offsetWidth / 2,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div 
      className="flex flex-col min-h-screen p-4 md:p-6 bg-white"
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
    >
      {/* Simple Header */}
      <div className="mb-6 text-center">
        <h2 className="text-2xl md:text-3xl text-center m-auto font-bold mb-2 text-[#00008B]">
          Our Team & Clients
        </h2>
        <p className="text-sm md:text-base text-center m-auto text-[#5a5a5a] max-w-2xl mx-auto">
          Explore moments from our organization's events and gatherings
        </p>
      </div>
      
      {/* Current Photo Info */}
      <div className="mb-4 p-4 bg-[white] border border-[#7DF9FF] rounded-lg shadow-md">
        <h3 className="text-lg md:text-xl font-semibold text-[#212166] mb-1">
          {galleryItems[activeIndex].title}
        </h3>
        <p className="text-sm md:text-base text-[#5a5a5a]">
          {galleryItems[activeIndex].description}
        </p>
      </div>
      
      {/* Image Gallery Scroll */}
      <div className="w-full mb-6">
        <div 
          id="image-scroll-container"
          className="flex overflow-x-auto pb-4 snap-x snap-mandatory hide-scrollbar"
        >
          <div className="flex space-x-3 px-2">
            {galleryItems.map((item, index) => (
              <div 
                key={item.id}
                id={`image-${index}`}
                onClick={() => scrollToImage(index)}
                className="flex-shrink-0 snap-center cursor-pointer transition-all duration-300"
                style={{ 
                  transform: index === activeIndex ? 'scale(1.05)' : 'scale(0.95)',
                  opacity: index === activeIndex ? 1 : 0.7,
                }}
              >
                <div className={`relative overflow-hidden rounded-lg ${index === activeIndex ? 'ring-4 ring-blue-400' : ''}`}>
                  <img 
                    src={item.imageUrl} 
                    alt={item.title}
                    className="h-48 w-64 sm:h-56 sm:w-72 md:h-64 md:w-80 object-cover"
                  />
                  <div className="absolute bottom-0 left-0 right-0 p-2 bg-gradient-to-t from-black/70 to-transparent">
                    <h4 className="text-white text-sm font-medium truncate">
                      {item.title}
                    </h4>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        
        {/* Navigation Dots */}
        <div className="flex justify-center mt-2 space-x-2">
          {galleryItems.map((_, index) => (
            <button
              key={index}
              onClick={() => scrollToImage(index)}
              className="rounded-full transition-all duration-300"
              style={{ 
                width: index === activeIndex ? '10px' : '8px',
                height: index === activeIndex ? '10px' : '8px',
                backgroundColor: index === activeIndex ? '#1e40af' : '#cbd5e1'
              }}
              aria-label={`Go to image ${index + 1}`}
            />
          ))}
        </div>
      </div>
      
      {/* Custom CSS */}
      <style jsx>{`
        .hide-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </div>
  );
};

export default Photoes;